<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" max-width="600px" @keydown="checkEsc">
      <v-card>          
        <div class="controls-bar" >
          <input
            v-show="false"
            v-on:change="addImageFile($event)"
            id="cameraFileInput"
            type="file"
            accept="image/*, video/*"
            capture="environment"
            alt="camera"
          />
          <v-spacer></v-spacer>
          <v-btn icon @click="getImage">
            <v-avatar tile>
              <i aria-hidden="true" class="v-icon material-icons">photo_camera</i>
            </v-avatar>
          </v-btn>
          <v-btn icon @click="delImage" :disabled="!currentScreenshotIsNew">
            <v-avatar tile>
              <i aria-hidden="true" class="v-icon material-icons">delete</i>
            </v-avatar>
          </v-btn>
          <v-btn @click="closeDialog">{{ $t('global.close') }}</v-btn>
        </div>
        <v-card-text>
          <v-carousel
            :cycle="false"
            reverse-transition="fade-transition"
            transition="fade-transition"
            v-model="currentScreenshot"
            cover
          >
            <v-carousel-item
              v-for="(item, i) in screenshots"
              :key="i"
              v-html="item.html"
              @click=""
            ></v-carousel-item>
          </v-carousel>
        </v-card-text>
        <v-card-actions> </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import router from '@/router'
import i18n from '@/plugins/i18n'
import {v4 as uuidv4} from 'uuid';

export default {
  name: 'camera',
  props: {
    docImages: [],
  },
  data: () => ({
    dialog: false,
    screenshots: [],
    currentScreenshot: null,
    screenshot: undefined,
  }),
  watch: {
  },
  computed: {
    currentScreenshotIsNew(){
      try{
        return this.screenshots[this.currentScreenshot].id?false:true
      } catch(error) {
        return false
      }
    }
  },
  methods: {
    show() {
      this.$nextTick(() => {
        this.dialog = true
        //this.getCameraSelection()
        this.screenshots = [...this.docImages]
        this.screenshots.forEach((el) => {
          if(!el.html){
            if(el.data.indexOf('data:video')==-1){
              el.html='<img width="100%" height="500px" style="object-fit: contain" src="'+el.data +'"></img>'
            } else {
              el.html='<video width="100%" height="450px" src="'+ el.data +'" controls></video>'
              //el.html= '<iframe width="100%" height="500px" src="'+ el.data +'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'            
            }
          }
        })
        if(this.screenshots.length>0){
          this.screenshot = this.screenshots[0]
        }
      })
    },
    addImageFile(event){
        const cameraInput = document.getElementById("cameraFileInput")
        const cameraFile = cameraInput.files[0]
        const tmpPath = URL.createObjectURL(cameraFile)
        if(cameraFile){
          const reader = new FileReader();
          reader.onloadend = () => {   
            if(reader.result.indexOf('data:video')==-1){
              this.screenshot = { 
                data: reader.result , 
                path: tmpPath,
                html: '<img width="100%" height="500px" style="object-fit: contain" src="'+tmpPath +'"></img>',
                id:null,
                preId: uuidv4()
              }
            } else {     
              this.screenshot = { 
                data: reader.result , 
                path: tmpPath,
                html:'<video width="100%" height="450px" src="'+ tmpPath +'" controls></video>',
                //html: '<iframe width="100%" height="500px" src="'+ tmpPath +'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>',
                id:null,
                preId: uuidv4()
              }
            }
            this.screenshots.push(this.screenshot)
          };
          reader.readAsDataURL(cameraFile);
        }
    },
    getImage(){
      let fileInput = document.getElementById("cameraFileInput")
      fileInput.click() 
    },
    delImage() {
      if (this.screenshots.length > 0) {
        let delIndex = this.currentScreenshot
        this.currentScreenshot = 0       
        this.screenshots = this.screenshots.filter((item, i) => {
          return i != delIndex
        })
      }
    },
    closeDialog(){
      this.$emit('updateImages', this.screenshots)
      this.dialog = false
    },
    checkEsc(ev) {
      if (ev.keyCode === 27) {
        closeDialog()
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '../_scss/mixins';
.screenshot-avatar {
  width: 100px;
  height: 60px;
  border-radius: 4px;
  border: 2px solid whitesmoke;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background: white;
}
.screenshot-image {
  width: 150px;
  height: 90px;
  border-radius: 4px;
  border: 2px solid whitesmoke;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  bottom: 5px;
  left: 10px;
  background: white;
}

.display-cover {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 95%;
  margin: auto;
  position: relative;
}


.controls-bar {
  display: flex;
}

</style>
